import theme from '@theme';
import { Col as BootstrapCol } from 'react-bootstrap';
import styled from 'styled-components';

import TitleSection from '../../identity-card/TitleSection';
import { useAppDispatch } from '../../../../../app/hooks';
import { RootState } from '../../../../../app/store';
import { useSelector } from 'react-redux';
import React, { useEffect } from 'react';
import { loadHistories } from '@features/siteStatusV2/reducer/historySlice';
import Histories from './Histories';
import { useTranslation } from 'react-i18next';
import { addUsers } from '@features/siteStatusV2/reducer/userSlice';
import { TranslationNamespaces } from '../../../../../locales/constants/translationNamespaces.enum';

interface ActivitiesColumnProps {
  id: string;
}

const ActivitiesColumn: React.FC<ActivitiesColumnProps> = ({ id }) => {
  const { t } = useTranslation(TranslationNamespaces.SITE_STATUS);
  const dispatch = useAppDispatch();
  const { isHistoriesLoading, histories, error } = useSelector((state: RootState) => state.history);

  useEffect(() => {
    dispatch(loadHistories({ id }));
  }, []);

  useEffect(() => {
    if (histories) {
      dispatch(addUsers(histories.map((history) => history.creator)));
    }
  }, [histories]);

  return (
    <Col xs={5}>
      <TitleSection>{t('report.activities')}</TitleSection>
      <Histories isHistoryLoading={isHistoriesLoading} histories={histories} error={error} />
    </Col>
  );
};

const Col = styled(BootstrapCol)`
  background-color: ${theme.palette.grey[100]};
  height: 100vh;
  padding: 0.5rem;
  overflow: hidden;
`;

export default ActivitiesColumn;
